import React, { memo, useEffect, useState } from "react";
import { ColorPicker, useColor } from "react-color-palette";

import "react-color-palette/css";

import styles from "./sidetabs.module.css";

import { Col, List, Popover, Row } from "antd";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { PiMinusSquareFill, PiPlusSquareFill } from "react-icons/pi";
import img1 from "../../../../../assets/staticImages/templates/template1.png";
import img2 from "../../../../../assets/staticImages/templates/template2.png";
import img3 from "../../../../../assets/staticImages/templates/template3.png";
import img4 from "../../../../../assets/staticImages/templates/template4.png";
import img5 from "../../../../../assets/staticImages/templates/template5.png";
import img6 from "../../../../../assets/staticImages/templates/template6.png";
import img7 from "../../../../../assets/staticImages/templates/template7.png";
import img8 from "../../../../../assets/staticImages/templates/template8.png";
import { SubmitButton, TextComponent } from "../../../../../components";
import { IoMdResize } from "react-icons/io";
import { TbTextPlus } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../../Store/Middlewares/EventPlanningMiddleware";

const data = [
  {
    title: "Flower Delight",
    img: img1,
  },
  {
    title: "Blue Heaven",
    img: img2,
  },
  {
    title: "Colorful Temp",
    img: img3,
  },
  {
    title: "Teal Magic",
    img: img4,
  },
  {
    title: "Elegant",
    img: img5,
  },
  {
    title: "Soft Template",
    img: img6,
  },
  {
    title: "Artistic",
    img: img7,
  },
  {
    title: "Floral",
    img: img8,
  },
  {
    title: "Flower Delight",
    img: img1,
  },
  {
    title: "Blue Heaven",
    img: img2,
  },
  {
    title: "Colorful Temp",
    img: img3,
  },
  {
    title: "Teal Magic",
    img: img4,
  },
  {
    title: "Elegant",
    img: img5,
  },
  {
    title: "Soft Template",
    img: img6,
  },
  {
    title: "Artistic",
    img: img7,
  },
  {
    title: "Floral",
    img: img8,
  },
];

const RenderItem = memo(({ item, setTempData }) => {
  return (
    <div
      className={styles.imgCont}
      onClick={() => setTempData(item)}
      key={item?.id}
    >
      <img className={styles.imageSim} src={item.image} alt="example" />
    </div>
  );
});

export const SideTemplates = ({ setTempData }) => {
  const dispatch = useDispatch();
  const Templates = useSelector(
    (state) => state.EventPlanningReducer.Templates
  );
  useEffect(() => {
    dispatch(EventPlanningMiddleware.getTemplates());
  }, []);
  return (
    <List
      className={styles.listClass}
      grid={{
        xs: 1,
        sm: 1,
        md: 1,
        lg: 1,
        xl: 1,
        xxl: 1,
      }}
      dataSource={Templates}
      renderItem={(item) => (
        <RenderItem item={item} setTempData={setTempData} />
      )}
    />
  );
};

const ColapsableItem = ({ children, title }) => {
  const [isColapsed, setisColapsed] = useState(false);
  return (
    <Row
      className={`${styles.colapseCont} ${
        isColapsed && title == "Styles" ? styles.isActive : ""
      } `}
    >
      <Row
        className={styles.headerCont}
        onClick={() => setisColapsed(!isColapsed)}
      >
        <Col>
          <TextComponent text={title} textClass={styles.headerTitle} />
        </Col>
        <Col>
          {isColapsed ? (
            <BsChevronUp className={styles.colapseIcon} />
          ) : (
            <BsChevronDown className={styles.colapseIcon} />
          )}
        </Col>
      </Row>

      {/* <Row> */}
      {isColapsed && children}
      {/* </Row> */}
    </Row>
  );
};

const fonts = [
  { font: "Poppins", fontFamily: "'Poppins', sans-serif" },
  { font: "Sacramento", fontFamily: "'Sacramento', cursive" },
  { font: "Baskerville Old Face", fontFamily: "Baskerville Old Face" },
  { font: "Lexend", fontFamily: "'Lexend', sans-serif" },
  { font: "Californian FB", fontFamily: "Californian" },
];

export const SideStyles = ({
  TextsList,
  setTextsList,
  slectedIndex,
  setResize,
  resize,
  onAddText,
}) => {
  const [color, setColor] = useColor(
    TextsList?.[slectedIndex]?.style?.color
      ? TextsList?.[slectedIndex]?.style?.color
      : "#000000"
  );
  const ChangeStyle = (value) => {
    if (slectedIndex === null) {
      return;
    }
    let cpylist = [...TextsList];
    cpylist.splice(slectedIndex, 1, {
      ...TextsList[slectedIndex],
      style: {
        ...TextsList[slectedIndex].style,
        ...value,
      },
    });
    setTextsList(cpylist);
  };

  const content = (
    <div>
      <ColorPicker
        color={color}
        hideInput
        onChange={(value) => {
          if (slectedIndex != null) {
            ChangeStyle({
              color: value.hex,
            });
          }

          setColor(value);
        }}
      />
    </div>
  );

  return (
    <>
      <ColapsableItem title={"Styles"}>
        <List
          className={styles.fontsList}
          grid={{
            xs: 1,
            sm: 1,
            md: 1,
            lg: 1,
            xl: 1,
            xxl: 1,
          }}
          dataSource={fonts}
          renderItem={(font) => (
            <TextComponent
              text={font?.font}
              style={{ fontFamily: font?.fontFamily }}
              textClass={styles.textStyles}
              onClick={() => {
                ChangeStyle({
                  fontFamily: font?.fontFamily,
                });
              }}
            />
          )}
        />
      </ColapsableItem>

      <ColapsableItem title={"size"}>
        <Row className={styles.sizeCont}>
          <Col>
            <PiMinusSquareFill
              size={30}
              className={styles.icon}
              cursor="pointer"
              onClick={() => {
                ChangeStyle({
                  fontSize: TextsList[slectedIndex].style.fontSize - 1,
                });
              }}
            />
          </Col>
          <Col>
            <TextComponent
              text={TextsList[slectedIndex]?.style?.fontSize}
              textClass={styles.sizeText}
            />
          </Col>
          <Col>
            <PiPlusSquareFill
              size={30}
              className={styles.icon}
              cursor="pointer"
              onClick={() => {
                ChangeStyle({
                  fontSize: TextsList[slectedIndex].style.fontSize + 1,
                });
              }}
            />
          </Col>

          <Col>
            <IoMdResize
              size={25}
              className={resize ? styles.icon : ""}
              cursor="pointer"
              onClick={() => {
                setResize(!resize);
              }}
            />
          </Col>
        </Row>
      </ColapsableItem>

      <ColapsableItem title={"Formatting"}>
        <Row className={styles.formatCont}>
          <Col>
            <Popover content={content} title="Select Color">
              <text style={{ textDecoration: "underline red" }}>A</text>
            </Popover>
          </Col>
          <Col>
            <text
              style={{ fontWeight: "bold" }}
              onClick={() => {
                if (!TextsList?.[slectedIndex]?.style?.fontWeight) {
                  ChangeStyle({
                    fontWeight: "bold",
                  });
                } else {
                  ChangeStyle({
                    fontWeight: "",
                  });
                }
              }}
            >
              B
            </text>
          </Col>
          <Col>
            <text
              style={{ fontStyle: "italic", fontFamily: "initial" }}
              onClick={() => {
                if (!TextsList?.[slectedIndex]?.style?.fontStyle) {
                  ChangeStyle({
                    fontStyle: "italic",
                  });
                } else {
                  ChangeStyle({
                    fontStyle: "",
                  });
                }
              }}
            >
              I
            </text>
          </Col>
          <Col>
            <text
              style={{ textDecoration: "underline" }}
              onClick={() => {
                if (!TextsList?.[slectedIndex]?.style?.textDecoration) {
                  ChangeStyle({
                    textDecoration: "underline",
                  });
                } else {
                  ChangeStyle({
                    textDecoration: "",
                  });
                }
              }}
            >
              U
            </text>
          </Col>
        </Row>
        <Row className={styles.formatCont} onClick={onAddText}>
          <TextComponent text="Add Text" style={{ fontSize: 18 }} />
          <TbTextPlus size={25} cursor={"pointer"} />
        </Row>
      </ColapsableItem>
    </>
  );
};
